export const no = {
  message: {
    layout: {
      login: 'Logg inn',
      logout: 'Logg ut'
    },
    login: {
      language: 'Språk',
      back: 'Tilbake',
      userName: 'Brukernavn',
      password: 'Brukerpassord',
      authFailed: 'Godkjenning mislyktes',
      enterUserName: 'Skriv inn brukernavn',
      enterPassword: 'Skriv inn passord',
      enterConfirmPassword: 'Gjenta passord',
      resetNow: 'Nullstill',
      invalidPassword: 'Ugyldig passord',
      unauthorizedMsg: 'Ingen tillatelse',
      forgotPassword: 'Glemt passord?',
      mailNotFound: 'Epostadressen ekisterer ikke',
      linkShared: 'Lenke for tilbakestilling av passord har blitt sendt!',
      office365: 'Logg inn med Office 365',
      or: 'Eller'
    },
    common: {
      close: 'Lukk',
      newUpdate: 'Ny oppdatering tilgjengelig!',
      translate: 'Oversette',
      required: 'Kreves',
      refresh: 'Forfriske',
      name: 'Navn',
      english: 'Engelsk',
      norwegian: 'Norsk',
      save: 'Lagre',
      send: 'Sende',
      edit: 'Endre',
      cancel: 'Avbryt',
      update: 'Oppdater',
      delete: 'Slett',
      updateAndClose: 'Oppdater og lukk',
      savedSuccess: 'Lagret',
      addedSucess: 'Opprettet',
      updatedSuccess: 'Oppdatert',
      deleteSuccess: 'Slettet',
      backToList: 'Tilbake til listen',
      search: 'Søk',
      yes: 'Ja',
      no: 'Nei',
      deleteMsg: 'Slettet',
      loadingMsg: 'Laster inn, vennligst vent',
      deleteConfirm: 'Bekreft sletting',
      areYouSure: 'Er du sikker på at du vil slette?',
      validationIssue: 'Vennligst sjekk de obligatoriske feltene!',
      invalidNumber: 'Feil nummer',
      warning: 'Varsel!',
      confirmation: 'Bekreftelse',
      filters: 'Filters',
      others: 'Others'
    },
    dashboard: {
      scanText: 'Skann ordrenummer eller strekkode',
      customerOrder: 'Kundeordre',
      receiveSupplierOrder: 'Innkjøpsordre',
      adjustmentOrders: 'Justeringsordre',
      transferOrders: 'Overføringsordre',
      cycleCount: 'Varetelling',
      product: 'Produkter',
      inStoreSale: 'In store sale'
    },
    product: {
      noProductFound: 'Ingen produkter funnet!',
      minQty: 'Min.ant.',
      orderQty: 'Best.ant.',
      qty: 'Antall',
      qtyShort: 'Ant.',
      batch: 'Batch',
      scanLoc: 'Skan lok.',
      noLocFound: 'Ingen lokasjon funnet!'
    },
    order: {
      products: 'Produkter',
      avail: 'Tilgj.',
      ordered: 'Best.',
      orderedshort: 'B.',
      shipmentshort: 'S.',
      confirmedshort: 'C.',
      requestedshort: 'R.',
      send_week: 'Uke',
      received: 'Mot.',
      pickedQty: 'Plu.',
      pickOrder: 'Plukk ordre',
      delivery: 'Lev',
      rest: 'Rest',
      complete: 'Ferdig',
      pick: 'Plukk',
      scanProduct: 'Skann strekkode for et produkt',
      scanBatch: 'Skann batchnummer',
      picked: 'Plukket',
      toPick: 'Skal plukkes',
      location: 'Lok',
      pickLocation: 'Velg lokasjon',
      qtyExceeds: 'Antall overskrider',
      noOrderFound: 'Ingen ordre funnet!',
      notValidBatch: 'Batchnummer er ugyldig!',
      receiveOrder: 'Motta ordre',
      receive: 'Motta',
      batchExists: 'Batchnummer eksisterer allerede!',
      receiveWarning: 'Vil du legge til {qty} stk {product} på lager?',
      receiveLessWarning: 'Mottatt antall er lavere enn bestilt. Vil du motta {qty} stk av {product}?',
      completedSuccess: 'Completed successfully!',
      addFreight: 'Vil du legge til frakt ?',
      cost: 'Kostnad',
      price: 'Pris',
      orderedQtyHigh: 'Antall mottatt er høyere enn bestilt, vil du fortsette?',
      collect: 'Collect',
      receiving: 'Mottar',
      availableToPick: 'Avail qty(s) to receive',
      adjust: 'Juster',
      orderComplete: 'Ordre vil bli fullført. Fortsette?',
      customer: 'Kunde',
      yourReference: 'Deres referanse',
      standardOrderText: 'Standard ordretekst',
      total: 'Total',
      selectSuppliers: 'Select suppliers'
    },
    ccsheet: {
      warehouse: 'Lager',
      created: 'Opprettet',
      counted: 'Telt',
      count: 'Telle',
      reCount: 'omtelling',
      closeComplete: 'Lukk og fullfør',
      unit: 'Enh',
      stock: 'Lager',
      scanLocation: 'Skann eller skriv inn lokasjon',
      nextLoc: 'Neste lok',
      info: 'Melding!',
      continueCount: 'Fortsett å telle',
      clearAndRecount: 'Nullstill og tell om',
      completeRecount: 'Fullfør omtelling',
      ccsheetComplete: 'Telleskjema vil bli fullført. Vil du fortsette?',
      noSheetFound: 'Ingen telleskjema funnet!',
      noProductOnLocation: 'Ingen produkter funnet på denne lokasjonen!',
      stockTake: 'Telling har blitt fullført for denne lokasjonen. Ønsker du å forsette med denne lokasjonen eller nullstille data og telle om igjen?',
      ccsheetAddProduct: 'Produkt ligger ikke i telleskjema. Vil du legge til?'
    }
  }
}
